import { render, staticRenderFns } from "./bestellungAusfuehren.vue?vue&type=template&id=2237f47e"
import script from "./bestellungAusfuehren.vue?vue&type=script&lang=js"
export * from "./bestellungAusfuehren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2237f47e')) {
      api.createRecord('2237f47e', component.options)
    } else {
      api.reload('2237f47e', component.options)
    }
    module.hot.accept("./bestellungAusfuehren.vue?vue&type=template&id=2237f47e", function () {
      api.rerender('2237f47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/bestellungAusfuehren.vue"
export default component.exports